var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 87,
    viewBox: "0 0 77 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9781 11.4484L46.1191 20.3381L48.2095 22.2431L52.8724 11.2898L49.9781 11.4484Z",
    fill: "#940006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0759 11.4484L32.9349 20.3381L30.8445 22.2431L26.1816 11.2898L29.0759 11.4484Z",
    fill: "#940006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8711 27.1639L20.0715 33.9899L21.197 30.3388L12.9966 23.989L11.8711 27.1639Z",
    fill: "#940006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5759 27.1639L57.3755 33.9899L56.25 30.3388L64.4504 23.989L65.5759 27.1639Z",
    fill: "#940006"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14609 30.9179C12.6451 30.9179 16.2922 27.4081 16.2922 23.0787C16.2922 18.7492 12.6451 15.2395 8.14609 15.2395C3.64713 15.2395 0 18.7492 0 23.0787C0 27.4081 3.64713 30.9179 8.14609 30.9179Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14609 30.118C12.6451 30.118 16.2922 26.7873 16.2922 22.6787C16.2922 18.5702 12.6451 15.2395 8.14609 15.2395C3.64713 15.2395 0 18.5702 0 22.6787C0 26.7873 3.64713 30.118 8.14609 30.118Z",
    fill: "#940006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7388 28.3756C12.0128 28.3756 15.4776 25.435 15.4776 21.8075C15.4776 18.1801 12.0128 15.2395 7.7388 15.2395C3.46478 15.2395 0 18.1801 0 21.8075C0 25.435 3.46478 28.3756 7.7388 28.3756Z",
    fill: "url(#paint0_radial_638_1390)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.73963 28.3755C12.0137 28.3755 15.4785 25.4349 15.4785 21.8075C15.4777 21.0069 15.3073 20.2154 14.9784 19.4836C14.7203 19.9857 14.3901 20.4483 13.998 20.8572C12.8465 22.0551 11.2782 22.7854 9.68006 23.2736C7.61369 23.905 5.38676 24.172 3.28084 23.6843C2.08379 23.4107 0.965294 22.8723 0.00976562 22.1097C0.195993 25.5966 3.58511 28.3755 7.73963 28.3755Z",
    fill: "#DBA75C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95468 25.7351C9.52934 25.7351 10.8058 24.5349 10.8058 23.0543C10.8058 21.5738 9.52934 20.3735 7.95468 20.3735C6.38003 20.3735 5.10352 21.5738 5.10352 23.0543C5.10352 24.5349 6.38003 25.7351 7.95468 25.7351Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68308 25.0649C9.10773 25.0649 10.2626 24.0147 10.2626 22.7192C10.2626 21.4237 9.10773 20.3735 7.68308 20.3735C6.25842 20.3735 5.10352 21.4237 5.10352 22.7192C5.10352 24.0147 6.25842 25.0649 7.68308 25.0649Z",
    fill: "#574120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32643 21.9821C6.92631 21.9821 7.41262 21.502 7.41262 20.9098C7.41262 20.3175 6.92631 19.8374 6.32643 19.8374C5.72654 19.8374 5.24023 20.3175 5.24023 20.9098C5.24023 21.502 5.72654 21.9821 6.32643 21.9821Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5297 21.2406C11.7294 21.2406 12.702 20.2805 12.702 19.096C12.702 17.9116 11.7294 16.9514 10.5297 16.9514C9.32998 16.9514 8.35742 17.9116 8.35742 19.096C8.35742 20.2805 9.32998 21.2406 10.5297 21.2406Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9605 30.9179C72.4595 30.9179 76.1066 27.4081 76.1066 23.0787C76.1066 18.7492 72.4595 15.2395 67.9605 15.2395C63.4616 15.2395 59.8145 18.7492 59.8145 23.0787C59.8145 27.4081 63.4616 30.9179 67.9605 30.9179Z",
    fill: "#FFBF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9605 30.118C72.4595 30.118 76.1066 26.7873 76.1066 22.6787C76.1066 18.5702 72.4595 15.2395 67.9605 15.2395C63.4616 15.2395 59.8145 18.5702 59.8145 22.6787C59.8145 26.7873 63.4616 30.118 67.9605 30.118Z",
    fill: "#940006"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5533 28.3756C71.8273 28.3756 75.292 25.435 75.292 21.8075C75.292 18.1801 71.8273 15.2395 67.5533 15.2395C63.2792 15.2395 59.8145 18.1801 59.8145 21.8075C59.8145 25.435 63.2792 28.3756 67.5533 28.3756Z",
    fill: "url(#paint1_radial_638_1390)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.554 28.3755C71.828 28.3755 75.2928 25.4349 75.2928 21.8075C75.292 21.0069 75.1217 20.2154 74.7928 19.4836C74.5346 19.9857 74.2044 20.4483 73.8123 20.8572C72.6608 22.0551 71.0925 22.7854 69.4945 23.2736C67.428 23.905 65.2011 24.172 63.0952 23.6843C61.8981 23.4107 60.7797 22.8723 59.8242 22.1097C60.0103 25.5966 63.3994 28.3755 67.554 28.3755Z",
    fill: "#DBA75C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7691 25.7351C69.3438 25.7351 70.6203 24.5349 70.6203 23.0543C70.6203 21.5738 69.3438 20.3735 67.7691 20.3735C66.1945 20.3735 64.918 21.5738 64.918 23.0543C64.918 24.5349 66.1945 25.7351 67.7691 25.7351Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4975 25.0649C68.9222 25.0649 70.0771 24.0147 70.0771 22.7192C70.0771 21.4237 68.9222 20.3735 67.4975 20.3735C66.0729 20.3735 64.918 21.4237 64.918 22.7192C64.918 24.0147 66.0729 25.0649 67.4975 25.0649Z",
    fill: "#574120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1409 21.9821C66.7408 21.9821 67.2271 21.502 67.2271 20.9098C67.2271 20.3175 66.7408 19.8374 66.1409 19.8374C65.541 19.8374 65.0547 20.3175 65.0547 20.9098C65.0547 21.502 65.541 21.9821 66.1409 21.9821Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3441 21.2406C71.5439 21.2406 72.5164 20.2805 72.5164 19.096C72.5164 17.9116 71.5439 16.9514 70.3441 16.9514C69.1444 16.9514 68.1719 17.9116 68.1719 19.096C68.1719 20.2805 69.1444 21.2406 70.3441 21.2406Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0289 15.6784C29.5279 15.6784 33.175 12.1686 33.175 7.83918C33.175 3.50972 29.5279 0 25.0289 0C20.5299 0 16.8828 3.50972 16.8828 7.83918C16.8828 12.1686 20.5299 15.6784 25.0289 15.6784Z",
    fill: "#FFBF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0289 14.8785C29.5279 14.8785 33.175 11.5478 33.175 7.43923C33.175 3.33066 29.5279 0 25.0289 0C20.5299 0 16.8828 3.33066 16.8828 7.43923C16.8828 11.5478 20.5299 14.8785 25.0289 14.8785Z",
    fill: "#940006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6216 13.1363C28.8956 13.1363 32.3604 10.1957 32.3604 6.56827C32.3604 2.94085 28.8956 0.000244141 24.6216 0.000244141C20.3476 0.000244141 16.8828 2.94085 16.8828 6.56827C16.8828 10.1957 20.3476 13.1363 24.6216 13.1363Z",
    fill: "url(#paint2_radial_638_1390)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.6224 13.136C28.8971 13.136 32.3612 10.1954 32.3612 6.56797C32.3604 5.76742 32.1901 4.97588 31.8612 4.24414C31.603 4.74618 31.2728 5.2088 30.8807 5.61769C29.7292 6.81576 28.161 7.54586 26.5629 8.03407C24.4965 8.66552 22.2694 8.93254 20.1635 8.44478C18.9665 8.17122 17.8481 7.63281 16.8926 6.87018C17.0788 10.3572 20.4678 13.136 24.6224 13.136Z",
    fill: "#DBA75C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8375 10.4956C26.4121 10.4956 27.6887 9.29539 27.6887 7.81483C27.6887 6.33427 26.4121 5.13403 24.8375 5.13403C23.2628 5.13403 21.9863 6.33427 21.9863 7.81483C21.9863 9.29539 23.2628 10.4956 24.8375 10.4956Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5659 9.82537C25.9905 9.82537 27.1455 8.77518 27.1455 7.4797C27.1455 6.18422 25.9905 5.13403 24.5659 5.13403C23.1412 5.13403 21.9863 6.18422 21.9863 7.4797C21.9863 8.77518 23.1412 9.82537 24.5659 9.82537Z",
    fill: "#574120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2092 6.74263C23.8091 6.74263 24.2954 6.26251 24.2954 5.67026C24.2954 5.07801 23.8091 4.5979 23.2092 4.5979C22.6094 4.5979 22.123 5.07801 22.123 5.67026C22.123 6.26251 22.6094 6.74263 23.2092 6.74263Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4125 6.00114C28.6122 6.00114 29.5848 5.04097 29.5848 3.85653C29.5848 2.67209 28.6122 1.71191 27.4125 1.71191C26.2128 1.71191 25.2402 2.67209 25.2402 3.85653C25.2402 5.04097 26.2128 6.00114 27.4125 6.00114Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.525 15.6784C57.024 15.6784 60.6711 12.1686 60.6711 7.83918C60.6711 3.50972 57.024 0 52.525 0C48.026 0 44.3789 3.50972 44.3789 7.83918C44.3789 12.1686 48.026 15.6784 52.525 15.6784Z",
    fill: "#FFBF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.525 14.8785C57.024 14.8785 60.6711 11.5478 60.6711 7.43923C60.6711 3.33066 57.024 0 52.525 0C48.026 0 44.3789 3.33066 44.3789 7.43923C44.3789 11.5478 48.026 14.8785 52.525 14.8785Z",
    fill: "#940006"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1177 13.1363C56.3917 13.1363 59.8565 10.1957 59.8565 6.56827C59.8565 2.94085 56.3917 0.000244141 52.1177 0.000244141C47.8437 0.000244141 44.3789 2.94085 44.3789 6.56827C44.3789 10.1957 47.8437 13.1363 52.1177 13.1363Z",
    fill: "url(#paint3_radial_638_1390)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.1185 13.136C56.3925 13.136 59.8573 10.1954 59.8573 6.56797C59.8565 5.76743 59.6862 4.9759 59.3573 4.24414C59.0991 4.74616 58.7688 5.20877 58.3768 5.61769C57.2253 6.81576 55.6571 7.54586 54.059 8.03407C51.9926 8.66552 49.7655 8.93254 47.6596 8.44478C46.4626 8.17122 45.3442 7.63281 44.3887 6.87018C44.5748 10.3572 47.9639 13.136 52.1185 13.136Z",
    fill: "#DBA75C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3336 10.4956C53.9082 10.4956 55.1848 9.29539 55.1848 7.81483C55.1848 6.33427 53.9082 5.13403 52.3336 5.13403C50.7589 5.13403 49.4824 6.33427 49.4824 7.81483C49.4824 9.29539 50.7589 10.4956 52.3336 10.4956Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.062 9.82537C53.4866 9.82537 54.6415 8.77518 54.6415 7.4797C54.6415 6.18422 53.4866 5.13403 52.062 5.13403C50.6373 5.13403 49.4824 6.18422 49.4824 7.4797C49.4824 8.77518 50.6373 9.82537 52.062 9.82537Z",
    fill: "#574120"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7053 6.74263C51.3052 6.74263 51.7915 6.26251 51.7915 5.67026C51.7915 5.07801 51.3052 4.5979 50.7053 4.5979C50.1054 4.5979 49.6191 5.07801 49.6191 5.67026C49.6191 6.26251 50.1054 6.74263 50.7053 6.74263Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9086 6.00114C56.1083 6.00114 57.0809 5.04097 57.0809 3.85653C57.0809 2.67209 56.1083 1.71191 54.9086 1.71191C53.7089 1.71191 52.7363 2.67209 52.7363 3.85653C52.7363 5.04097 53.7089 6.00114 54.9086 6.00114Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8701 80.1973C15.8701 80.1973 5.53457 80.5065 9.60612 84.8354C13.6777 89.1644 29.6509 82.6709 29.6509 82.6709L15.8701 80.1973Z",
    fill: "url(#paint4_radial_638_1390)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8393 80.1973C62.8393 80.1973 73.1749 80.5065 69.1033 84.8354C65.0316 89.1644 49.0586 82.6709 49.0586 82.6709L62.8393 80.1973Z",
    fill: "url(#paint5_radial_638_1390)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4809 53.3311C70.0953 60.3799 74.4537 71.605 68.2873 78.2733C61.7665 85.3253 47.5269 84.4735 39.0067 84.4735C30.4864 84.4735 16.2468 85.3251 9.72603 78.2733C3.55968 71.6051 7.91808 60.3801 10.5325 53.3311C14.6141 42.3261 23.451 16.9455 39.0067 16.9453C54.5623 16.9451 63.3992 42.3263 67.4809 53.3311Z",
    fill: "url(#paint6_radial_638_1390)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4333 36.283C55.4979 26.4081 48.5049 16.9451 39.0067 16.9453C23.4511 16.9453 14.6142 42.3261 10.5325 53.3311C8.2649 59.4452 4.69003 68.699 7.80398 75.398C7.46612 73.0006 7.51893 70.5653 7.96041 68.1845C9.49114 60.0616 20.7802 19.4475 37.2353 18.5028C46.0628 17.9962 54.5036 27.3836 60.4333 36.283Z",
    fill: "#FFBF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1641 30.4141C26.1641 30.4141 37.2614 38.382 50.7126 30.4141C50.7126 30.4141 35.2437 34.398 26.1641 30.4141Z",
    fill: "#940006"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9721 31.969C28.9721 31.969 28.7716 26.9199 29.674 26.5239C30.5765 26.1279 34.688 27.3159 34.688 27.3159L33.0801 33.2941L28.9721 31.969Z",
    fill: "#FFDEF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8175 31.8795C47.8175 31.8795 48.0199 26.7852 47.1174 26.3892C46.2149 25.9932 42.1035 27.1812 42.1035 27.1812L43.8082 33.3194L47.8175 31.8795Z",
    fill: "#FFDEF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.4135 81.4777C19.1813 81.6088 19.9528 81.7235 20.7284 81.8123C27.9569 82.6398 35.6171 81.5528 42.731 80.2158C49.3425 78.9732 56.0344 77.2196 62.1307 74.3535C65.3905 72.821 68.7819 70.9193 71.407 68.4285C71.1842 63.1405 69.0285 57.5048 67.4807 53.3314C67.2678 52.7576 67.0403 52.1403 66.8012 51.4937C61.2586 60.3889 51.1085 66.6869 41.4332 70.273C34.3089 72.9137 26.663 74.4512 19.0321 74.0989C15.3819 73.9126 11.7675 73.2951 8.26607 72.2597C7.78108 72.1187 7.27363 71.9655 6.75586 71.7979C7.00053 73.4736 7.51945 75.0677 8.40303 76.5148C8.40326 76.5145 12.2238 79.5032 18.4135 81.4777Z",
    fill: "#940006"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3401 53.9807C10.3401 53.9807 29.0215 67.5191 31.0089 63.0063C32.9963 58.4935 15.9045 46.5667 13.9168 47.9408C11.9292 49.3149 9.74394 52.6073 10.3401 53.9807Z",
    fill: "url(#paint7_radial_638_1390)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9171 47.9407C11.9484 49.3013 9.78678 52.5446 10.3261 53.9404C11.1037 52.6815 12.15 51.6052 13.392 50.7863C14.353 50.1567 15.4892 49.6791 16.6334 49.8183C17.5558 49.9306 18.3779 50.4277 19.1613 50.9212C23.6792 53.7676 28.2562 57.1982 30.0649 62.1789C30.241 62.6535 30.3732 63.143 30.4598 63.6412C30.7052 63.4908 30.8972 63.269 31.0092 63.0062C32.9966 58.4934 15.9046 46.5672 13.9171 47.9407Z",
    fill: "#FFBF00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3879 53.4592C67.3879 53.4592 48.7065 66.9975 46.7191 62.4847C44.7316 57.9719 61.8235 46.0458 63.8112 47.4192C65.7988 48.7927 67.984 52.0857 67.3879 53.4592Z",
    fill: "url(#paint8_radial_638_1390)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8111 47.4192C65.7799 48.7798 67.9415 52.0232 67.4022 53.419C66.6245 52.1601 65.5783 51.0837 64.3362 50.2649C63.3753 49.6353 62.239 49.1575 61.0949 49.2969C60.1724 49.4092 59.3505 49.9063 58.5671 50.3999C54.049 53.2461 49.4721 56.6767 47.6634 61.6575C47.4872 62.1322 47.3551 62.6217 47.2684 63.1199C47.0231 62.9695 46.8311 62.7476 46.719 62.4848C44.7317 57.9719 61.8237 46.0458 63.8111 47.4192Z",
    fill: "#FFBF00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.08277 16.0408) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.876 16.0408) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9596 0.801544) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.446 0.801544) scale(16.5985 16.3807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-129.837 85.4536) scale(21.7256 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-264.338 85.4536) rotate(180) scale(21.7255 21.4173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7721 40.051) scale(46.7281 46.1438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.856 46.2378) scale(29.6729 29.2947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_638_1390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-390.966 45.7163) rotate(180) scale(29.6729 29.2945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppF);
export default __webpack_public_path__ + "static/media/appF.0e4423c7e8b1ec5da222cedb027869dd.svg";
export { ForwardRef as ReactComponent };